export enum Roles {
  Superadmin = 'SUPERADMIN',
  User = 'USER',
  Vcm = 'VCM',
  Pm = 'PM',
  Resident = 'RESIDENT',
  PM = "PM"
}
